var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({height:_vm.height+'px',marginLeft: '-10px',marginTop: '-10px',marginRight: '-10px'}),attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }